export default (content) => {
  try {
    return JSON.parse(content)
  }
  catch (error) {
    return content
  }
}
